<template>  
    <form class="form form_w400 form_pt100" @submit.prevent="login">
         
        <div class="form__head">
            <h2 class="form__title form__title_mb16">Reset password</h2>
        </div>  

        <div class="form__content"> 
            <div class="form-item mb24"> 
                <el-input 
                    placeholder="Password"
                    type="password" 
                    v-model="form.password" 
                    autocomplete="off"
                ></el-input>
            </div>
            
            <div class="form-item mb24"> 
                <el-input 
                    placeholder="Repeat password"
                    type="password" 
                    v-model="form.password" 
                    autocomplete="off"
                ></el-input>
            </div>

            <div class="form-item">
                <button 
                    class="btn btn_login" 
                    :disabled="true"
                    :class="{
                        'btn_disabled': true
                    }"
                >Save</button>
            </div>  
        </div>
    </form> 
</template>

<script>
export default {
    name: 'authRestore',
    data() {
        return {
            form: {}
        }
    },
    methods: {
        login() {}
    }
}
</script>  